import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Respondent, AssignRespondentInput } from '../../models/Respondent';
import { isRcnSurveyApplication, stringNotEmpty } from 'src/app/shared/lib/custom-tools';
import { debounceTime, distinctUntilChanged, switchMap, tap, catchError, first } from 'rxjs/operators';
import { zip } from 'rxjs';
import { ToastrService, LoadingIndicatorService } from '@kpmg-tax/ui';
import { Messages } from '../../constants/messages';
import { AssignRespondentModel } from '../../models/assign-respondent-model';
import { BaseResponse } from '../../models/base-response.model';
import { Project } from '../../models/project.model';
import { AddMenuItems } from 'src/app/shared/models/add-menu-items.model';
import { DatePipe } from '@angular/common';
import { role } from 'src/app/shared/constants/role-enum';
import { ActivityTypeEnum } from 'src/app/shared/constants/activity-type.enum';
import { SurveyTypeEnum } from 'src/app/shared/constants/survey-type.enum';
import { APP_CONSTANTS } from 'src/app/shared/constants/app-constants';
import { SESSION_CONST } from 'src/app/shared/constants/session-constants';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { SessionService } from '../../session-service/session.service';
import { CreateStudyService } from '../create-study/services/create-study.service';
import { AssignSurveyRespondentService } from './assign-survey-respondent.service';
import { SurveyDetailsService } from '../../../survey/survey-details/survey-details.service';
import { DefineProjectsService } from '../../../data-analysis-summary/define-projects/define-projects.service';
// import { Options, ChangeContext } from '@angular-slider/ngx-slider';
import {
    ProjectsDTO,
    ActivitiesDTO,
    UnAssignedProjectsActivitesDTO,
    SurveyProjectsActivitesDTO,
    SelectedDeletedProjectActivity
} from '../../models/edit-survey/getsurvey-projects-activity.model';
import { UserDataService } from '../../../core/services/user-data.service';

@Component({
    selector: 'assign-survey-respondent',
    templateUrl: './assign-survey-respondent.component.html',
    styleUrls: ['./assign-survey-respondent.component.scss'],
})
export class AssignSurveyRepondentComponent implements OnInit, OnDestroy {
    private _subscriptions: Subscription[] = [];
    emailReminderFrequencyOptions: any = {
        floor: 0,
        ceil: 10,
        getPointerColor: (value: number): string => {
            if (value === 0) {
                return 'red';
            } else {
                return '#28a745';
            }
        }
    };
    surveyRespondents: Array<Respondent>;
    filteredSurveyRespondents: any = null;
    noResults: boolean = false;
    @Input() engagementId: number;
    @Input() surveyId: number;
    @Input() itemId?: number;
    @Input() canSMEAddProjects: boolean;
    userRole: role = role.none;
    showAddNewProjectButton: boolean = false;
    surveyRepondent: AssignRespondentInput;
    respondentName: string;
    respondentDetails: AssignRespondentModel;
    existingRepondents: any;
    clientId: any;
    targetForm: FormGroup;
    surveyDetailsPostData: any;
    targetFormSubmitted: boolean = false;
    surveyDetails: any;
    surveyNameCopy: string;
    isNameChanged: boolean = false;
    @ViewChild('dpDueDate', { static: true }) dpDueDate;
    minDate: Date = new Date();
    unAssignedProjects: Array<ProjectsDTO> = [];
    unAssignedActivity: Array<ActivitiesDTO> = [];
    unAssignedNQAActivity: Array<ActivitiesDTO> = [];
    unAssignedNWTActivity: Array<ActivitiesDTO> = [];
    assignedProjects: Array<ProjectsDTO> = [];
    assignedActivity: Array<ActivitiesDTO> = [];
    assignedNQAActivity: Array<ActivitiesDTO> = [];
    assignedNWTActivity: Array<ActivitiesDTO> = [];
    selectedProjects: Array<ProjectsDTO> = [];
    selectedActivity: Array<ActivitiesDTO> = [];
    selectedNQAActivity: Array<ActivitiesDTO> = [];
    selectedNWTActivity: Array<ActivitiesDTO> = [];
    deletedProjects: Array<ProjectsDTO> = [];
    deletedActivity: Array<ActivitiesDTO> = [];
    deletedNQAActivity: Array<ActivitiesDTO> = [];
    deletedNWTActivity: Array<ActivitiesDTO> = [];
    addProject: boolean = false;
    addActivity: boolean = false;
    addNQAActivity: boolean = false;
    addNWTActivity: boolean = false;
    filteredProject: any = null;
    filteredActivity: any = null;
    filteredNQAActivity: any = null;
    filteredNWTActivity: any = null;
    surveyInfo: any;
    showProject: boolean = true;
    showActivity: boolean = true;
    isSMESelected: boolean = false;
    isDisabled: boolean = true;
    dueDate: Date = null;
    assignedProjectsbckup: Array<any>;
    assignedActivitybckup: Array<ActivitiesDTO>;
    assignedNQAActivitybckup: Array<ActivitiesDTO>;
    assignedNWTActivitybckup: Array<ActivitiesDTO>;
    changed = new Map<string, boolean>();
    date: Date = null;
    adSME: boolean = false;
    showAddUserModel: boolean = false;
    clientName: string;
    isSME: boolean = true;
    isRcnSurveyApp: boolean = false;
    addUserName: string = '';
    reminderValue: any;
    kpmgUsers: any[] = [];
    surveyRespondentsDemo: any[];
    respondentSelected: any[] = [];
    respondentSelectedbckup: any[] = [];
    respondentData: any;
    deletedRespondents: any[] = [];

    constructor(
        public _rightSideDrawerService: RightSideDrawerService,
        public _sessionService: SessionService,
        private _assignSurveyRepondentService: AssignSurveyRespondentService,
        private _surveyDetailsService: SurveyDetailsService,
        private _projectsService: DefineProjectsService,
        private _loader: LoadingIndicatorService,
        private _createStudyService: CreateStudyService,
        private _toastrService: ToastrService,
        private formBuilder: FormBuilder,
        public datepipe: DatePipe,
        private userDataService: UserDataService,
    ) {
        this.getValuesFromSession();
        this._subscriptions.push(
            this.userDataService.userDetails$.subscribe(( { roleId }) => {
              this.userRole = roleId;
            })
        )
    }

    private getValuesFromSession() {
        this.engagementId = Number(this._sessionService.getSession('engagementId'));
        this.surveyInfo = JSON.parse(this._sessionService.getSession('surveyDetails'));
        this.clientName = this._sessionService.getSession('clientName');
    }

    get f() {
        return this.targetForm?.controls;
    }

    ngOnInit() {
        this.setProjectsAndActivitiesStatus();
        this.respondentDetails = this._assignSurveyRepondentService.getSurveyRepondentDatas();
        this.respondentData = this.respondentDetails.respondentData;
        this.surveyDetails = this._assignSurveyRepondentService.getSurveyDetails();
        this.surveyNameCopy = this.surveyDetails.surveyName;
        this.existingRepondents = {
            userData: this.respondentDetails,
        };
        if (this.respondentData != null) {
            this.respondentData.forEach(element => {
                let initialRespondent = {
                    displayName: element.displayName,
                    engagementId: element.engagementId,
                    surveyId: element.surveyId,
                    userId: element.userId,
                    isReassign: this.respondentDetails.isReassign,
                };
                this.respondentSelected.push(initialRespondent);
                this.respondentSelected = [...this.respondentSelected];
                this.respondentSelectedbckup.push(initialRespondent);
            });
        }
        this.isRcnSurveyApp = isRcnSurveyApplication();
        this.initializeForm();
        this.initializeChangedValue();
        this.initializeMenu();
        this.fetchProjectActvity(this.engagementId, this.surveyDetails.surveyId);
    }

    public noWhitespaceValidator() {
        let control = this.targetForm.controls['surveyName'];
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : control.setErrors({ incorrect: true });
    }

    setProjectsAndActivitiesStatus() {
        const surveyTypeId = Number(this.surveyInfo.surveyTypeId);
        switch (surveyTypeId) {
            case SurveyTypeEnum.NoProjectActivitiesByPercentage:
            case SurveyTypeEnum.NoProjectActivitiesBySelection:
                this.showProject = false;
                break;
            case SurveyTypeEnum.ProjectsByPercentageNoActivity:
            case SurveyTypeEnum.ProjectsBySelectionNoActivity:
                this.showActivity = false;
                break;
            case SurveyTypeEnum.NoProjectNoActivity:
                this.showProject = false;
                this.showActivity = false;
        }
    }

    initializeChangedValue() {
        this.changed['projects'] = false;
        this.changed['activities'] = false;
        this.changed['NQA'] = false;
        this.changed['NWT'] = false;
    }

    initializeMenu() {
        switch (this.itemId) {
            case AddMenuItems['Add Projects']:
                this.expandProjects();
                break;
            case AddMenuItems['Add Activities']:
                this.expandActivities();
                break;
            case AddMenuItems['Add NQAs']:
                this.expandNQAActivities();
                break;
            case AddMenuItems['Add NWTs']:
                this.expandNWTActivities();
                break;
        }
    }

    initializeForm() {
        this.targetForm = this.formBuilder.group({
            surveyId: [''],
            surveyName: [{ value: '', disabled: this.isRcnSurveyApp }, Validators.required],
            reminderFrequency: [
                0,
                [Validators.required, Validators.pattern('^([0-9]|1[0-4])$')],
            ],
            dueDate: [{ value: '', disabled: this.isRcnSurveyApp }],
        });
        setTimeout(() => {
            this.targetForm.patchValue({
                surveyId: this.surveyDetails.surveyId,
                surveyName: this.surveyDetails && this.surveyDetails.surveyName
                    ? this.surveyDetails.surveyName.trim().substring(0, 100)
                    : this.surveyDetails.surveyName,
                reminderFrequency: this.surveyDetails.reminderFrequency,
                dueDate: this.datepipe.transform(
                    this.surveyDetails.dueDate,
                    'MM/dd/yyyy',
                ),
            });
            this.reminderValue = this.surveyDetails.reminderFrequency;
            this.showAddNewProjectButton = this.canSMEAddProjects || this.userRole === role.admin || this.userRole === role.champion;
        });
    }

    addNewProjectButtonClick() {
        this.saveTmpDataToStorage();
        this._projectsService.eiPrjTableDataFiltered = this.getExistingProjectNumbers();
        this._rightSideDrawerService.closeRightSideDrawer({drawerName: APP_CONSTANTS.EDIT_SURVEY_ADD_PROJECT, isProjectFromSurvey: true});
    }

    private getExistingProjectNumbers(): Project[] {
        const existingProjectNumbers = [
            ...this.assignedProjects.map(p => p.projectNumber),
            ...this.unAssignedProjects.map(p => p.projectNumber)
        ];
        const result = existingProjectNumbers.map(pNum => {
            return { projectNumber: pNum } as Project
        });
        return result;
    }

    assignRespondent() {
        this._subscriptions.push(
            this._assignSurveyRepondentService
                .assignSurveyRespondent(this.surveyRepondent)
                .subscribe((result: any) => {
                    if (result.result) {
                        this._toastrService.setSuccessMessage(Messages.AssignSurveyRespondentSuccess);
                    } else {
                        this._toastrService.setErrorMessage(result.errorMessage,
                             //Messages.ErrorMessage
                             );
                    }
                    this._rightSideDrawerService.closeRightSideDrawer();
                })
        );

    }

    deleteRow(row: ProjectsDTO | ActivitiesDTO, deleteMethod: string) {
        this[deleteMethod](row);
    }

    closeRightSideDrawer() {
        this.respondentName = null;
        this.surveyRepondent = null;
        this._rightSideDrawerService.closeRightSideDrawer();
    }

    /*TYPE A HEAD CODES */

    respondentFormatter() {
        return '';
    }

    bindNewuser(user: any) {
        this.showAddUserModel = false;
        this.targetForm.patchValue({
            respondentName: user.displayName,
        });
        this.respondentName = user.displayName;
        this.surveyRepondent = {
            displayName: user.displayName,
            engagementId: Number(this._sessionService.getSession('engagementId')),
            surveyId: this.surveyId,
            userId: user.userId,
            isReassign: this.respondentDetails.isReassign,
        };
        if (this.respondentName) {
            this.isSMESelected = true;
        } else {
            this.isSMESelected = false;
        }
        this.isChanged();
    }
    // Selected item from auto suggest
    onRespondentSelected(respondent: any) {
        if (respondent.item.displayName.includes('Click here to add user.')) {
            respondent.item.displayName = '';
            this.respondentName = '';
            this.showAddUserModel = true;
        } else {
            this.respondentName = respondent.item.displayName;
            this.surveyRepondent = {
                displayName: respondent.item.displayName,
                engagementId: Number(this._sessionService.getSession('engagementId')),
                surveyId: this.surveyId,
                userId: respondent.item.userId,
                isReassign: this.respondentDetails.isReassign,
            };
            let index = this.respondentSelected.findIndex(
                item => item.userId === this.surveyRepondent.userId,
            );
            if (index !== -1) {
                return;
            }
            let deletedIndex = this.deletedRespondents.findIndex(
                item => item.userId === this.surveyRepondent.userId,
            );
            if (deletedIndex !== -1) {
                this.deletedRespondents.splice(deletedIndex, 1);
            }
            this.respondentSelected.push(this.surveyRepondent);
            this.respondentSelected = [...this.respondentSelected];

            let found = this.respondentSelected.every(i => this.respondentSelectedbckup.includes(i));
            if (found) {
                this.isDisabled = true;
            } else {
                this.isDisabled = false;
            }
        }
    }
    removeRespondent(row: any) {
        let removeIndex = this.respondentSelected.findIndex(
            item => item.userId === row.userId,
        );
        let respondentDeleted = this.respondentSelected.filter(e => e.userId == row.userId);
        this.deletedRespondents.push(respondentDeleted[0]);
        this.deletedRespondents = [...this.deletedRespondents];

        this.respondentSelected.splice(removeIndex, 1);
        this.respondentSelected = [...this.respondentSelected];
        let found = this.respondentSelectedbckup.every(i => this.respondentSelected.includes(i));
        if (!found) {
            this.isDisabled = false;
        } else {
            this.isDisabled = true;
        }
        if (this.respondentSelected.length === 0) {
            this.isSMESelected = false;
        }
    }

    cleanTargetFormToPost = () => {
        let formData = this.targetForm.value;
        formData.dueDate = this.datepipe.transform(
            this.targetForm.get('dueDate').value,
            'MM/dd/yyyy',
        );
        let newSurveyName = this.getSurveyName(formData.surveyName);
        formData.surveyName = newSurveyName;
        let selectedSmes = Array.prototype.map.call(this.respondentSelected, s => s.userId).toString();
        let deletedSmes = Array.prototype.map.call(this.deletedRespondents, s => s.userId).toString();
        let respondentDetails = {
            selectedSmes: selectedSmes,
            deletedSmes: deletedSmes

        };
        this.surveyDetailsPostData = {
            updateSurveyMetaDataRequestDTO: formData,
            surveyRespondentRequestDTO: respondentDetails
        };
        this.surveyDetails.surveyName = newSurveyName;
        this.surveyDetails.reminderFrequency = formData.reminderFrequency;
        this.surveyDetails.users = this.respondentSelected;
        if (
            typeof formData.respondentName === 'undefined' ||
            !formData.respondentName
        ) {
            this.surveyDetails.userName = '';
        } else {
            this.surveyDetails.userName =
                typeof formData.respondentName.userName === 'undefined'
                    ? formData.respondentName
                    : formData.respondentName.userName;
        }

        this.surveyDetails.dueDate = this.datepipe.transform(
            formData.dueDate,
            'MM/dd/yyyy',
        );
        this.surveyDetailsPostData.updateSurveyMetaDataRequestDTO.engagementId = Number(
            this._sessionService.getSession('engagementId'),
        );
        return this.surveyDetailsPostData;
    }

    private getSurveyName(surveyName: string): string {
        return stringNotEmpty(surveyName)
            ? surveyName.trim().substring(0, 100)
            : this.surveyDetails.surveyName;
    }

    checkChangeName() {
        if (this.targetForm.value.surveyName !== this.surveyNameCopy) {
            this.isNameChanged = true;
        } else {
            this.isNameChanged = false;
        }
    }

    submitButtonClick() {
        this.isDisabled = true;
        if (this.isNameChanged) {
            let engagementId = Number(this._sessionService.getSession('engagementId'));
            let sName = this.targetForm.value.surveyName;
            this._subscriptions.push(this._assignSurveyRepondentService
                .checkSurveyNameExists(engagementId, sName)
                .subscribe((data: BaseResponse) => {
                    if (!data.result) {
                        this.updateSurveyMetaData();
                    } else {
                        this._toastrService.setErrorMessage(data.errorMessage);
                        this.isDisabled = false;
                    }
                    this.targetFormSubmitted = true;
                })
            );
        } else {
            this.updateSurveyMetaData();
        }
    }

    updateSurveyMetaData() {
        this._subscriptions.push(
            this._assignSurveyRepondentService
                .updateSurveyMetadata(this.cleanTargetFormToPost())
                .subscribe((data: any) => {
                    if (data.result) {
                        this.respondentData = this.surveyDetails.users;
                        this._assignSurveyRepondentService.setSurveyDetails(this.surveyDetails);
                        this._sessionService.setSession('surveyDetails', JSON.stringify(this.surveyDetails));
                        this._assignSurveyRepondentService.refreshData(this.surveyDetails);
                        this._toastrService.setSuccessMessage(
                            Messages.AssignSurveyRespondent.SURVEY_DETAILS_UPDATE_SUCCESS,
                        );
                        this.submitProjectsAndActivities();
                    } else {
                        this._toastrService.setErrorMessage(
                            data.errorMessage,
                            //Messages.ErrorMessage,
                        );
                    }
                },
                    error => {
                        this._toastrService.setErrorMessage(
                            //Messages.ErrorMessage,
                        );
                    })
        );
    }

    private submitProjectsAndActivities() {
        if (this.checkProjectsAndActivitiesToBeUpdated()) {
            this.submitData();
        } else {
            this._rightSideDrawerService.closeRightSideDrawer();
        }
    }

    private checkProjectsAndActivitiesToBeUpdated(): boolean {
        if (this.selectedNQAActivity.length > 0) {
            this.selectedActivity.push(...this.selectedNQAActivity);
        }
        if (this.deletedNQAActivity.length > 0) {
            this.deletedActivity.push(...this.deletedNQAActivity);
        }
        if (this.selectedNWTActivity.length > 0) {
            this.selectedActivity.push(...this.selectedNWTActivity);
        }
        if (this.deletedNWTActivity.length > 0) {
            this.deletedActivity.push(...this.deletedNWTActivity);
        }
        return this.selectedProjects.length > 0 ||
            this.selectedActivity.length > 0 ||
            this.deletedProjects.length > 0 ||
            this.deletedActivity.length > 0;
    }

    private submitData() {
        this._subscriptions.push(
            this._assignSurveyRepondentService
                .editSurveyProjectActivity(
                    this.selectedProjects,
                    this.selectedActivity,
                    this.deletedProjects,
                    this.deletedActivity,
                    this.surveyDetails.surveyId,
                )
                .subscribe((data: BaseResponse) => {
                    if (data.success) {
                        this._surveyDetailsService.loadSurveyDetails(
                            this.surveyDetails.surveyId,
                        );
                    } else {
                        this.isDisabled = false;
                        this._toastrService.setErrorMessage(
                            Messages.AssignSurveyRespondent.ProjectActivityUpdationError,
                        );
                    }
                    this._rightSideDrawerService.closeRightSideDrawer();
                },
                    error => {
                        // If request fails,  give an error.
                        this.isDisabled = false;
                        this._toastrService.setErrorMessage(
                            Messages.AssignSurveyRespondent.BackEndError,
                        );
                        this._rightSideDrawerService.closeRightSideDrawer();
                        console.log(error);
                    }
                )
        );
    }

    trimSpecialChar(ctrl: any) {
        this.targetForm.controls[ctrl].setValue(
            this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._/ ]/g, ''),
        );
    }

    // reset form content.
    public resetRightSideDrawerData = () => {
        this.targetForm.reset();
        this.targetFormSubmitted = false;
    }

    clearDueDate() {
        this.targetForm.controls.dueDate.setValue(null);
        this.isChanged();
    }

    openDatePickerEnd() {
        this.dpDueDate.toggle();
    }

    expandProjects() {
        this.addProject = true;
        this.addActivity = false;
        this.addNQAActivity = false;
        this.addNWTActivity = false;
    }
    expandActivities() {
        this.addProject = false;
        this.addActivity = true;
        this.addNQAActivity = false;
        this.addNWTActivity = false;
    }
    expandNQAActivities() {
        this.addProject = false;
        this.addActivity = false;
        this.addNQAActivity = true;
        this.addNWTActivity = false;
    }
    expandNWTActivities() {
        this.addProject = false;
        this.addActivity = false;
        this.addNQAActivity = false;
        this.addNWTActivity = true;
    }

    //----------Survey Project & Activities---
    fetchProjectActvity(engagementId: number, surveyId: number) {
        this._loader.display(true);

        zip(
            this._assignSurveyRepondentService.getSurveyProjectsActivities(engagementId, surveyId),
            this._assignSurveyRepondentService.getUnAssignedProjectsActivities(engagementId, surveyId))
            .pipe(first())
            .subscribe((data: [BaseResponse, BaseResponse]) => {
                this._loader.display(false);

                if (data[0].success) {
                    this.setAssignedProjectsAndActivities(data[0].result as SurveyProjectsActivitesDTO);
                }
                if (data[1].success) {
                    this.setUnAssignedProjectsAndActivities(data[1].result as UnAssignedProjectsActivitesDTO);
                }

                this.restoreTmpDataFromStorage();
            });
    }

    private setAssignedProjectsAndActivities(result: SurveyProjectsActivitesDTO) {
        this.assignedProjects = result.projects;
        this.assignedProjectsbckup = [...this.assignedProjects];

        this.assignedActivity = result.activities.filter(
            x => x.activityType === ActivityTypeEnum.Activity,
        );
        this.assignedActivitybckup = [...this.assignedActivity];

        this.assignedNQAActivity = result.activities.filter(
            x => x.activityType === ActivityTypeEnum.NQA,
        );
        this.assignedNQAActivitybckup = [...this.assignedNQAActivity];

        this.assignedNWTActivity = result.activities.filter(
            x => x.activityType === ActivityTypeEnum.NWT,
        );
        this.assignedNWTActivitybckup = [...this.assignedNWTActivity];
    }


    private setUnAssignedProjectsAndActivities(result: UnAssignedProjectsActivitesDTO) {
        this.unAssignedProjects = result.projects;

        this.unAssignedActivity = result.activities.filter(
            x => x.activityType == ActivityTypeEnum.Activity,
        );
        this.unAssignedNQAActivity = result.activities.filter(
            x => x.activityType === ActivityTypeEnum.NQA,
        );
        this.unAssignedNWTActivity = result.activities.filter(
            x => x.activityType === ActivityTypeEnum.NWT,
        );
    }

    projectFormatter() {
        return '';
    }

    searchProjects = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            debounceTime(150), // Wait 150 milliseconds for typing to stop
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                this.noResults = false;
            }),
            switchMap(term => {
                this.filteredProject = null;
                return this.searchingProjects(term).pipe(
                    switchMap((data: any) => {
                        this.noResults = data.length === 0;
                        return of(data);
                    }),
                    catchError(() => {
                        this.noResults = true;
                        return of([]);
                    }),
                );
            }),
        )

    private searchingProjects(term: any): Observable<any> {
        if (this.unAssignedProjects.length === 0) {
            this.unAssignedProjects.push({
                projectId: 0,
                isLocked: false,
                name: 'No Data Found',
            });
        }
        return of(
            this.unAssignedProjects.filter(item =>
                item.name.toLowerCase().includes(term.toLowerCase()),
            ),
        );
    }


    // Selected item from auto suggest
    onProjectSelected(selectedProject: ProjectsDTO) {
        if (selectedProject.name !== 'No Data Found') {
            this.unAssignedProjects = this.unAssignedProjects.filter(
                x => x.projectId !== selectedProject.projectId,
            );
            this.assignedProjects.push(selectedProject);
            this.assignedProjects = [...this.assignedProjects];
            this.selectedProjects.push(selectedProject);
            this.deletedProjects = this.deletedProjects.filter(
                x => x.projectId !== selectedProject.projectId,
            );
        } else {
            this.unAssignedProjects = this.unAssignedProjects.filter(
                x => x.projectId !== selectedProject.projectId,
            );
        }
        const found = this.assignedProjectsbckup.some(
            el => el.projectId === selectedProject.projectId,
        );

        if (
            found &&
            this.assignedProjectsbckup.length === this.assignedProjects.length
        ) {
            this.changed['projects'] = false;
        } else {
            this.changed['projects'] = true;
        }
        this.isChanged();
    }

    deleteProject(row: ProjectsDTO) {
        if (this.assignedProjects.length === 1) {
            this._toastrService.setErrorMessage(
                Messages.AssignSurveyRespondent.AtleastOneProject,
            );
        } else {
            this.assignedProjects = this.assignedProjects.filter(
                x => x.projectId !== row.projectId,
            );
            this.assignedProjects = [...this.assignedProjects];
            this.deletedProjects.push(row);
            this.unAssignedProjects.push(row);
            this.selectedProjects = this.selectedProjects.filter(
                x => x.projectId !== row.projectId,
            );
        }
        let found = true;
        this.assignedProjectsbckup.forEach(element => {
            if (
                !this.assignedProjects.some(el => el.projectId === element.projectId)
            ) {
                found = false;
            }
        });

        if (
            found &&
            this.assignedProjectsbckup.length === this.assignedProjects.length
        ) {
            this.changed['projects'] = false;
        } else {
            this.changed['projects'] = true;
        }
        this.isChanged();
    }

    activityFormatter() {
        return '';
    }

    searchActivity = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            debounceTime(150), // Wait 150 milliseconds for typing to stop
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                this.noResults = false;
            }),
            switchMap(term => {
                this.filteredActivity = null;
                return this.searchingActivity(term).pipe(
                    switchMap((data: any) => {
                        this.noResults = data.length === 0;
                        return of(data);
                    }),
                    catchError(() => {
                        this.noResults = true;
                        return of([]);
                    }),
                );
            }),
        )

    private searchingActivity(term: any): Observable<any> {
        if (this.unAssignedActivity?.length === 0) {
            this.unAssignedActivity.push({
                activityId: 0,
                isLocked: false,
                activityType: 3,
                name: 'No Data Found',
            });
        }
        return of(
            this.unAssignedActivity.filter(item =>
                item.name.toLowerCase().includes(term.toLowerCase()),
            ),
        );
    }

    // Selected item from auto suggest
    onActivitySelected(data: ActivitiesDTO) {
        if (data.name !== 'No Data Found') {
            this.unAssignedActivity = this.unAssignedActivity.filter(
                x => x.activityId !== data.activityId,
            );
            this.assignedActivity.push(data);
            this.assignedActivity = [...this.assignedActivity];
            this.selectedActivity.push(data);
            this.deletedActivity = this.deletedActivity.filter(
                x => x.activityId !== data.activityId,
            );
        } else {
            this.unAssignedActivity = this.unAssignedActivity.filter(
                x => x.activityId !== data.activityId,
            );
        }
        const found = this.assignedActivitybckup.some(
            el => el.activityId === data.activityId,
        );

        if (
            found &&
            this.assignedActivitybckup.length === this.assignedActivity.length
        ) {
            this.changed['activities'] = false;
        } else {
            this.changed['activities'] = true;
        }
        this.isChanged();
    }

    deleteActivity(row: ActivitiesDTO) {
        if (this.assignedActivity.length === 1) {
            this._toastrService.setErrorMessage(
                Messages.AssignSurveyRespondent.AtleastOneActivity,
            );
        } else {
            this.assignedActivity = this.assignedActivity.filter(
                x => x.activityId !== row.activityId,
            );
            this.assignedActivity = [...this.assignedActivity];
            this.deletedActivity.push(row);
            this.unAssignedActivity.push(row);
            this.selectedActivity = this.selectedActivity.filter(
                x => x.activityId !== row.activityId,
            );
        }
        let found = true;
        this.assignedActivitybckup.forEach(element => {
            if (
                !this.assignedActivity.some(el => el.activityId === element.activityId)
            ) {
                found = false;
            }
        });

        if (
            found &&
            this.assignedActivitybckup.length === this.assignedActivity.length
        ) {
            this.changed['activities'] = false;
        } else {
            this.changed['activities'] = true;
        }
        this.isChanged();
    }

    activityNQAFormatter() {
        return '';
    }

    searchNQAActivity = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            debounceTime(150), // Wait 150 milliseconds for typing to stop
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                this.noResults = false;
            }),
            switchMap(term => {
                this.filteredNQAActivity = null;
                return this.searchingNQAActivity(term).pipe(
                    switchMap((data: any) => {
                        this.noResults = data.length === 0;
                        return of(data);
                    }),
                    catchError(() => {
                        this.noResults = true;
                        return of([]);
                    }),
                );
            }),
        )

    activityNWTFormatter() {
        return '';
    }

    searchNWTActivity = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            debounceTime(150), // Wait 150 milliseconds for typing to stop
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                this.noResults = false;
            }),
            switchMap(term => {
                this.filteredNWTActivity = null;
                return this.searchingNWTActivity(term).pipe(
                    switchMap((data: any) => {
                        this.noResults = data.length === 0;
                        return of(data);
                    }),
                    catchError(() => {
                        this.noResults = true;
                        return of([]);
                    }),
                );
            }),
        )

    private searchingNQAActivity(term: any): Observable<any> {
        if (this.unAssignedNQAActivity.length === 0) {
            this.unAssignedNQAActivity.push({
                activityId: 0,
                isLocked: false,
                activityType: 3,
                name: 'No Data Found',
            });
        }
        return of(
            this.unAssignedNQAActivity.filter(item =>
                item.name.toLowerCase().includes(term.toLowerCase()),
            ),
        );
    }

    private searchingNWTActivity(term: any): Observable<any> {
        if (this.unAssignedNWTActivity.length === 0) {
            this.unAssignedNWTActivity.push({
                activityId: 0,
                isLocked: false,
                activityType: 4,
                name: 'No Data Found',
            });
        }
        return of(
            this.unAssignedNWTActivity.filter(item =>
                item.name.toLowerCase().includes(term.toLowerCase()),
            ),
        );
    }

    // Selected item from auto suggest
    onNQAActivitySelected(data: ActivitiesDTO) {
        if (data.name !== 'No Data Found') {
            this.unAssignedNQAActivity = this.unAssignedNQAActivity.filter(
                x => x.activityId !== data.activityId,
            );
            this.assignedNQAActivity.push(data);
            this.assignedNQAActivity = [...this.assignedNQAActivity];
            this.selectedNQAActivity.push(data);
            this.deletedNQAActivity = this.deletedNQAActivity.filter(
                x => x.activityId !== data.activityId,
            );
        } else {
            this.unAssignedNQAActivity = this.unAssignedNQAActivity.filter(
                x => x.activityId !== data.activityId,
            );
        }
        const found = this.assignedNQAActivitybckup.some(
            el => el.activityId === data.activityId,
        );

        if (
            found &&
            this.assignedNQAActivitybckup.length === this.assignedNQAActivity.length
        ) {
            this.changed['NQA'] = false;
        } else {
            this.changed['NQA'] = true;
        }
        this.isChanged();
    }

    onNWTActivitySelected(data: ActivitiesDTO) {
        if (data.name !== 'No Data Found') {
            this.unAssignedNWTActivity = this.unAssignedNWTActivity.filter(
                x => x.activityId !== data.activityId,
            );
            this.assignedNWTActivity.push(data);
            this.assignedNWTActivity = [...this.assignedNWTActivity];
            this.selectedNWTActivity.push(data);
            this.deletedNWTActivity = this.deletedNWTActivity.filter(
                x => x.activityId !== data.activityId,
            );
        } else {
            this.unAssignedNWTActivity = this.unAssignedNWTActivity.filter(
                x => x.activityId !== data.activityId,
            );
        }
        const found = this.assignedNWTActivitybckup.some(
            el => el.activityId === data.activityId,
        );

        if (
            found &&
            this.assignedNWTActivitybckup.length === this.assignedNWTActivity.length
        ) {
            this.changed['NWT'] = false;
        } else {
            this.changed['NWT'] = true;
        }
        this.isChanged();
    }

    deleteNQAActivity(row: ActivitiesDTO) {
        if (this.assignedNQAActivity.length === 1) {
            this._toastrService.setErrorMessage(
                Messages.AssignSurveyRespondent.AtleastOneNQA,
            );
        } else {
            this.assignedNQAActivity = this.assignedNQAActivity.filter(
                x => x.activityId !== row.activityId,
            );
            this.assignedNQAActivity = [...this.assignedNQAActivity];
            this.deletedNQAActivity.push(row);
            this.unAssignedNQAActivity.push(row);
            this.selectedNQAActivity = this.selectedNQAActivity.filter(
                x => x.activityId !== row.activityId,
            );
        }

        let found = true;
        this.assignedNQAActivitybckup.forEach(element => {
            if (
                !this.assignedNQAActivity.some(
                    el => el.activityId === element.activityId,
                )
            ) {
                found = false;
            }
        });

        if (
            found &&
            this.assignedNQAActivitybckup.length === this.assignedNQAActivity.length
        ) {
            this.changed['NQA'] = false;
        } else {
            this.changed['NQA'] = true;
        }
        this.isChanged();
    }

    deleteNWTActivity(row: ActivitiesDTO) {
        if (this.assignedNWTActivity.length === 1) {
            this._toastrService.setErrorMessage(
                Messages.AssignSurveyRespondent.AtleastOneNWT,
            );
        } else {
            this.assignedNWTActivity = this.assignedNWTActivity.filter(
                x => x.activityId !== row.activityId,
            );
            this.assignedNWTActivity = [...this.assignedNWTActivity];
            this.deletedNWTActivity.push(row);
            this.unAssignedNWTActivity.push(row);
            this.selectedNWTActivity = this.selectedNWTActivity.filter(
                x => x.activityId !== row.activityId,
            );
        }

        let found = true;
        this.assignedNWTActivitybckup.forEach(element => {
            if (
                !this.assignedNWTActivity.some(
                    el => el.activityId === element.activityId,
                )
            ) {
                found = false;
            }
        });

        if (
            found &&
            this.assignedNWTActivitybckup.length === this.assignedNWTActivity.length
        ) {
            this.changed['NWT'] = false;
        } else {
            this.changed['NWT'] = true;
        }
        this.isChanged();
    }

    setDueDate(date: Date) {
        this.dueDate = date;
        this.isChanged();
    }

    isChanged() {
        let respondent = {
            sName:
                this.targetForm.get('surveyName').value === null
                    ? ''
                    : this.targetForm.get('surveyName').value,
            reminderFrequency: this.targetForm.get('reminderFrequency').value,
            dueDate: this.targetForm.get('dueDate').value,
        };
        let surveyDetails = this.surveyDetails.surveyName.replace(
            /[^a-zA-Z0-9-()._/ ]/g,
            '',
        );
        let respondentSME = respondent.sName.replace(/[^a-zA-Z0-9-()._/ ]/g, '');
        let dueDateOriginal = this.datepipe.transform(
            this.surveyDetails.dueDate,
            'MM/dd/yyyy',
        );
        let dueDate = this.datepipe.transform(this.dueDate, 'MM/dd/yyyy');
        if (
            this.changed['projects'] ||
            this.changed['activities'] ||
            this.changed['NQA'] ||
            this.changed['NWT']
        ) {
            this.isDisabled = false;
        } else if (
            respondentSME !== surveyDetails ||
            respondent.reminderFrequency !== this.surveyDetails.reminderFrequency ||
            dueDateOriginal !== dueDate
        ) {
            this.isDisabled = false;
            this._rightSideDrawerService.setMandatoryField(true, APP_CONSTANTS.EDIT_SURVEY);
        } else {
            this.isDisabled = true;
            this._rightSideDrawerService.setMandatoryField(false, '');
        }
    }
    closeModel(status: boolean) {
        this.showAddUserModel = status;
        this.isSMESelected = false;
    }
    getKPMGUsers(): void {
        this._subscriptions.push(
            this._createStudyService.kpmgUsersDataSource$.subscribe(kpmgUsersResponse => {
                if (kpmgUsersResponse && kpmgUsersResponse.result) {
                    this.kpmgUsers = kpmgUsersResponse.result;
                }
            })
        );
    }

    // sliderEvent(changeContext: ChangeContext) {
    //     this.isChanged();
    // }

    private saveTmpDataToStorage() {
        this._sessionService.removeItem(SESSION_CONST.SELECTED_PROJECTS_ACTIVITIES);
        let savedTmpData = [
            ...this.getSelectedDeletedProjectIds(this.selectedProjects, true),
            ...this.getSelectedDeletedProjectIds(this.deletedProjects, false),
            ...this.getSelectedDeletedActivityIds(this.selectedActivity, true),
            ...this.getSelectedDeletedActivityIds(this.deletedActivity, false),
            ...this.getSelectedDeletedActivityIds(this.selectedNQAActivity, true),
            ...this.getSelectedDeletedActivityIds(this.deletedNQAActivity, false),
            ...this.getSelectedDeletedActivityIds(this.selectedNWTActivity, true),
            ...this.getSelectedDeletedActivityIds(this.deletedNWTActivity, false)
        ];
        this._sessionService.setSession(
            SESSION_CONST.SELECTED_PROJECTS_ACTIVITIES,
            JSON.stringify(savedTmpData)
        );
    }

    private getSelectedDeletedProjectIds(projects: ProjectsDTO[], selected: boolean): SelectedDeletedProjectActivity[] {
        let ids: SelectedDeletedProjectActivity[] = [];
        projects.forEach(x => {
            ids.push({
                activityType: ActivityTypeEnum.Project,
                id: x.projectId,
                selected: selected
            } as SelectedDeletedProjectActivity);
        });
        return ids;
    }

    private getSelectedDeletedActivityIds(activities: ActivitiesDTO[], selected: boolean): SelectedDeletedProjectActivity[] {
        let ids: SelectedDeletedProjectActivity[] = [];
        activities.forEach(x => {
            ids.push({
                activityType: x.activityType,
                id: x.activityId,
                selected: selected
            } as SelectedDeletedProjectActivity);
        });
        return ids;
    }

    private restoreTmpDataFromStorage() {
        const projectsActivitiesJson = this._sessionService.getSession(SESSION_CONST.SELECTED_PROJECTS_ACTIVITIES);
        if (projectsActivitiesJson?.length > 0) {
            const savedData = JSON.parse(projectsActivitiesJson) as SelectedDeletedProjectActivity[];
            savedData.forEach(x => {
                switch (x.activityType) {
                    case ActivityTypeEnum.Project:
                        this.restoreTmpProjects(x);
                        break;
                    case ActivityTypeEnum.Activity:
                        this.restoreTmpActivities(x);
                        break;
                    case ActivityTypeEnum.NQA:
                        this.restoreTmpNQAActivities(x);
                        break;
                    case ActivityTypeEnum.NWT:
                        this.restoreTmpNWTActivities(x);
                        break;
                }
            });
        }
        this._sessionService.removeItem(SESSION_CONST.SELECTED_PROJECTS_ACTIVITIES);
    }

    private restoreTmpProjects(savedProject: SelectedDeletedProjectActivity) {
        if (savedProject?.selected) {
            const project = this.unAssignedProjects.find(p => p.projectId === savedProject?.id);
            if (project) {
                this.onProjectSelected(project);
            }
        }
        else {
            const project = this.assignedProjects.find(p => p.projectId === savedProject?.id);
            if (project) {
                this.deleteProject(project);
            }
        }
    }

    private restoreTmpActivities(savedActivity: SelectedDeletedProjectActivity) {
        if (savedActivity?.selected) {
            const activity = this.unAssignedActivity
                .find(a => a.activityType == ActivityTypeEnum.Activity && a.activityId === savedActivity?.id);
            if (activity) {
                this.onActivitySelected(activity);
            }
        }
        else {
            const activity = this.assignedActivity
                .find(a => a.activityType == ActivityTypeEnum.Activity && a.activityId === savedActivity?.id);
            if (activity) {
                this.deleteActivity(activity);
            }
        }
    }

    private restoreTmpNQAActivities(savedActivity: SelectedDeletedProjectActivity) {
        if (savedActivity?.selected) {
            const activity = this.unAssignedNQAActivity
                .find(a => a.activityType == ActivityTypeEnum.NQA && a.activityId === savedActivity?.id);
            if (activity) {
                this.onNQAActivitySelected(activity);
            }
        }
        else {
            const activity = this.assignedNQAActivity
                .find(a => a.activityType == ActivityTypeEnum.NQA && a.activityId === savedActivity?.id);
            if (activity) {
                this.deleteNQAActivity(activity);
            }
        }
    }

    private restoreTmpNWTActivities(savedActivity: SelectedDeletedProjectActivity) {
        if (savedActivity?.selected) {
            const activity = this.unAssignedNWTActivity
                .find(a => a.activityType == ActivityTypeEnum.NWT && a.activityId === savedActivity?.id);
            if (activity) {
                this.onNWTActivitySelected(activity);
            }
        }
        else {
            const activity = this.assignedNWTActivity
                .find(a => a.activityType == ActivityTypeEnum.NWT && a.activityId === savedActivity?.id);
            if (activity) {
                this.deleteNWTActivity(activity);
            }
        }
    }

    ngOnDestroy() {
        this._subscriptions.forEach(s => s.unsubscribe());
    }

}
